import { render, staticRenderFns } from "./ChooseCarMulti.vue?vue&type=template&id=01228803"
import script from "./ChooseCarMulti.vue?vue&type=script&lang=js"
export * from "./ChooseCarMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports